module.exports = require('../../es/object/assign');
